export const en = {
  nav: {
    home: "Home",
    services: "Services",
    apartments: "Properties",
    about: "About",
    gallery: "Portfolio",
    blog: "Blog",
    contact: "Contact",
    bookNow: "Contact Us",
    allServices: "All our services",
    gestionLocative: "Property Management",
    conciergerieService: "Concierge",
    aLaCarteService: "À la carte services",
    bailMobiliteService: "Mobility lease",
    yachtCharter: "Yacht Charter",
    billetterie: "Ticketing",
    automobiles: "Automobile",
    partnerLabel: "Partners",
    staffService: "Staff",
    faq: "FAQ",
    reviews: "Reviews"
  },
  hero: {
    subtitle: "Exceptional Lifestyle Services",
    ownerTitle1: "Your privileged access",
    ownerTitle2: "to peace of mind",
    title1: "Your gateway",
    title2: "to the unforgettable",
    title3: "in",
    titleHighlight: "Provence",
    description: "Short-term rental concierge based in Aix-en-Provence. Handpicked accommodation across Provence.",
    cta: "Discover Our Services",
    ctaSecondary: "View Properties",
    scrollDown: "Explore"
  },
  footer: {
    description: "Short-term rental concierge based in Aix-en-Provence. Handpicked accommodation across Provence.",
    quickLinks: "Navigation",
    services: "Services",
    contact: "Contact",
    newsletter: "Newsletter",
    newsletterDesc: "Receive our exclusive offers and updates.",
    yourEmail: "Your email",
    subscribe: "Subscribe",
    allRights: "All rights reserved.",
    legal: "Legal Notice",
    privacy: "Privacy Policy",
    toasts: {
      invalidEmail: "Please enter a valid email address",
      alreadySubscribed: "You are already subscribed to our newsletter!",
      thankYou: "Thank you for subscribing!",
      subscribed: "Subscribed successfully!",
      error: "An error occurred. Please try again."
    }
  },
  services: {
    subtitle: "Our Expertise",
    title: "Our Services",
    partnerSubtitle: "Privileged Partnerships",
    partnerTitle: "Ancillary Services",
    partnerDescription: "Trusted experts who share our attention to detail.",
    description: "A thoughtful range of services designed around your lifestyle on the French Riviera.",
    categories: {
      propertyManagement: {
        title: "Property Management",
        subtitle: "Seasonal Rentals",
        description: "Your property, our passion. A discreet presence that transforms each stay into a lasting memory.",
        features: [
          "Dynamic pricing strategy adapted to the market",
          "Professional photography and videography",
          "24/7 concierge for your guests",
          "High-end housekeeping and laundry",
          "Preventive maintenance and upkeep",
          "Multi-platform reservation management",
          "Active promotion on Instagram, Facebook, LinkedIn, TikTok & Google Ads",
          "Direct booking channel via our website — no platform service fees"
        ]
      },
      concierge: {
        title: "Concierge Services",
        subtitle: "Bespoke Experiences",
        description: "Reservations, transfers, errands and organization: we take care of everything during your stay.",
        features: [
          "Private chefs and catering service",
          "Personal butler service",
          "Starred restaurant reservations",
          "VIP club and event access",
          "Travel and transfer coordination",
          "Personal shopping and styling"
        ]
      },
      automotive: {
        title: "Automotive",
        subtitle: "Rentals & Experiences",
        description: "Rental of all-purpose vehicles, supercars and collector cars, varied experiences.",
        features: [
          "Exotic and supercar rentals",
          "Professional chauffeur service",
          "Private track experiences",
          "Automobile collection tours",
          "Airport and heliport delivery",
          "Rally and event accompaniment"
        ]
      },
      yachting: {
        title: "Yacht Charter",
        subtitle: "Maritime Escape",
        description: "Where sky and sea embrace. A horizon without limits, an intimacy beyond the waves.",
        features: [
          "Day and sunset charters",
          "All-inclusive weekly cruises",
          "Yacht buying and selling brokerage",
          "Professional crew management",
          "Customized itineraries",
          "Private events on board"
        ]
      },
      events: {
        title: "Exclusive Access",
        subtitle: "Private Events",
        description: "Doors that open only for the initiated. Where moments become legends.",
        features: [
          "VIP Cannes Film Festival",
          "Private screenings and premieres",
          "International fashion weeks",
          "Galas and private parties",
          "Art exhibitions and openings",
          "Concerts and sporting events"
        ]
      },
      staff: {
        title: "Staff",
        subtitle: "Household Personnel",
        description: "Silent excellence. Invisible presences that elevate every moment.",
        features: ["International private chefs", "Professional butlers", "Experienced housekeepers", "Event service staff", "Qualified childcare", "Security personnel", "Taxi / Private chauffeur"]
      },
      ticketing: {
        title: "Ticketing",
        subtitle: "Privileged Access",
        description: "Tickets for exclusive events, VIP access and hard-to-get seats.",
        features: ["Sold-out event tickets", "VIP boxes", "Backstage access", "Exclusive premieres", "Premium sporting events", "Concerts and shows"]
      },
      jet: {
        title: "Travel & Logistics",
        subtitle: "Private Aviation",
        description: "We manage travel logistics for our guests, ensuring a flawless and personalized experience.",
        features: ["Private jets on demand", "Helicopters", "VIP airport transfers", "Long-haul flights", "Onboard catering", "Luggage coordination"]
      },
      watches: {
        title: "Watches & Jewelry",
        subtitle: "Iconic Pieces",
        description: "Treasures that transcend time. The rarity of beauty, the beauty of rarity.",
        features: ["Collection watches", "Fine jewelry", "Rare vintage pieces", "Expert authentication", "Auction sales", "Secure safes"]
      }
    },
    cta: "Learn More",
    contactUs: "Contact Us"
  },
  about: {
    subtitle: "Our Story",
    title: "Conciergerie Cabassol",
    description: "Short-term rental concierge based in Aix-en-Provence. Handpicked accommodation across Provence, hotel standards. Owners: all-inclusive management, dedicated contact. Guests: tailor-made stay, local art de vivre.",
    philosophy: {
      subtitle: "Our Philosophy",
      title: "Attention to Detail",
      description1: "Conciergerie Cabassol is a short-term rental concierge service based in Aix-en-Provence. We manage handpicked accommodation — charming apartments, village houses, bastides, villas with pools — in Aix-en-Provence and across Provence. Our commitment: to bring hotel-grade standards to every property, with a single dedicated contact who knows the home, the owner and the region.",
      description2: "For owners, we handle the entire rental management process through an all-inclusive formula: professional photo & drone video shoot, listing creation and distribution across leading platforms, dynamic pricing, active promotion on social media (Instagram, Facebook, LinkedIn, TikTok) and Google Ads, guest welcome, cleaning, laundry, maintenance and incident management — 7 days a week. We also provide a direct booking channel via our website at no platform service fees. One dedicated contact, full transparency, and the assurance that your property is showcased and cared for as if it were our own.",
      description3: "For guests, we offer accommodation where every detail has been considered: quality linen, impeccable cleanliness, a personal welcome and local recommendations — restaurants, markets, beaches, walks, hidden gems. Our team lives here, knows Provence intimately and shares the best of local life with every visitor. Whether you are travelling as a family, a couple or with friends, your stay is tailored to you.",
      cta: "Discover Our Services"
    },
    values: {
      subtitle: "What Guides Us",
      title: "Our Values",
      items: [
        { title: "Trust", description: "A sincere and transparent relationship with our clients. We build lasting partnerships founded on integrity and mutual respect." },
        { title: "Serenity", description: "Peace of mind for our clients. We anticipate your needs so you can fully enjoy every moment." },
        { title: "Availability", description: "24/7 responsiveness for all your needs. A dedicated team at your service, at all times, to respond to every request." },
        { title: "Expertise", description: "In-depth knowledge of the region and exclusive partner network. Years of experience serving your satisfaction." }
      ]
    },
    timeline: {
      subtitle: "Our Journey",
      title: "Key Milestones",
      milestones: [
        { year: "2020", title: "Foundation", description: "Creation of Conciergerie Cabassol in Provence-Alpes-Côte d'Azur" },
        { year: "2022", title: "Events", description: "Expansion into event planning with Antoine" },
        { year: "2025", title: "Yacht Charter", description: "Launch of yacht charter service with Alexander" },
        { year: "2026", title: "Automotive", description: "Development of premium automotive services with Bowoods Travel" }
      ]
    },
    team: {
      subtitle: "Who we are",
      title: "Team",
      description: "",
      members: [
        { name: "Eliott Sore-Larregain", role: "Manager Conciergerie Cabassol", bio: "Experienced in hospitality and restaurant management, specialist in seasonal, medium and long-term rental management." },
        { name: "Anastacia Figuière", role: "Partnerships & Service Providers Manager", bio: "Specialist in partner and service provider coordination, ensuring service quality and network development." }
      ]
    },
    partners: {
      subtitle: "Our Network",
      title: "Partners",
      description: "Trusted experts who share our standards and dedication to personalized service.",
      members: [
        { name: "Bowoods Travel", role: "Automotive Concierge", bio: "Passionate about exceptional vehicles, expert in supercar rental and automotive experiences." },
        { name: "Alexander Suzanne", role: "Yacht Broker", bio: "Specialist in yacht brokerage and luxury Mediterranean cruises." },
        { name: "Antoine", role: "Event Concierge", bio: "Expert in private event planning and exclusive experiences on the French Riviera." }
      ]
    },
    cta: {
      title: "Let's Work Together",
      description: "Discover how our team can transform your vision of luxury and personalized service.",
      button: "Contact Us"
    },
    yearsExperience: "Years of experience serving demanding clients"
  },
  properties: {
    subtitle: "The Selection",
    title: "Our Accommodations",
    description: "Discover our selection of exceptional accommodations.",
    viewAll: "View All",
    perNight: "/night",
    filters: {
      all: "All",
      villa: "Villas",
      apartment: "Apartments",
      location: "Location",
      capacity: "Capacity"
    },
    viewDetails: "View Details",
    guests: "guests",
    bedrooms: "bedrooms"
  },
  contact: {
    subtitle: "Get in Touch",
    title: "Contact Us",
    description: "Our team is at your disposal to discuss your projects and needs.",
    infoTitle: "Information",
    sendMessage: "Send a Message",
    form: {
      name: "Full Name",
      email: "Email",
      phone: "Phone",
      subject: "Subject",
      message: "Your Message",
      send: "Send Message",
      sending: "Sending...",
      success: "Message sent successfully",
      error: "An error occurred"
    },
    info: {
      address: "Address",
      addressValue: "1 Traverse Notre-Dame, 13100 Aix-en-Provence",
      phone: "Phone",
      phoneValue: "+33 6 59 01 31 55",
      email: "Email",
      emailValue: "eliott@conciergeriecabassol.fr",
      hours: "Hours",
      hoursValue: "Mon-Sat: 9AM - 7PM"
    }
  },
  stats: {
    properties: "Properties Managed",
    clients: "Satisfied Clients",
    years: "Years of Experience",
    availability: "Availability"
  },
  testimonials: {
    subtitle: "Client experiences",
    title: "They trust us.",
    description: "Those who entrust. Those who stay.",
    viewAll: "View all reviews"
  },
  reviewsPage: {
    metaTitle: "Client Reviews | They trust us — Conciergerie Cabassol",
    metaDescription: "Read our clients' Google reviews. Conciergerie Cabassol: 5/5 stars for property management and concierge services in Provence.",
    title: "They trust us.",
    subtitle: "Client experiences",
    description: "Those who entrust. Those who stay.",
    leaveReview: "Leave a review on Google"
  },
  cta: {
    title: "Your Concierge, Your Peace of Mind",
    description: "A single point of contact to manage, welcome and elevate your stays in Provence & the French Riviera.",
    button: "Let's Talk"
  },
  faq: {
    subtitle: "Frequently Asked Questions",
    title: "Everything you need to know",
    items: [
      { question: "What services do you offer property owners?", answer: "We provide comprehensive property management: revenue estimation, professional listings, booking management, guest welcome, cleaning, maintenance and detailed financial reporting. A single point of contact manages everything for you." },
      { question: "Which areas do you cover?", answer: "We primarily operate in the Aix-en-Provence area and collaborate with trusted partners across Provence and the French Riviera, from Saint-Tropez to Monaco." },
      { question: "How does the concierge service work for travelers?", answer: "Once your booking is confirmed, a dedicated advisor assists you: personalized recommendations, restaurant reservations, excursion planning, vehicle rental, event tickets and any bespoke request." },
      { question: "What are your rates and are there hidden fees?", answer: "Our rates are transparent and tailored to each service. Property search is free for travelers. For owners, we offer clear packages based on a percentage of rental income. Contact us for a personalized quote." },
      { question: "Do you offer yacht and automobile services?", answer: "Yes, through our specialized partners: yacht charter and private cruises in the Mediterranean with Alexander, and supercar rental, track experiences and private chauffeur with Bowoods Travel." },
      { question: "How can I contact you and what is the response time?", answer: "You can reach us via the contact form, by email at eliott@conciergeriecabassol.fr or by phone. We guarantee a response within 24 hours, 7 days a week." }
    ]
  },
  gallery: {
    title: "Portfolio Gallery",
    subtitle: "Discover our exceptional properties and experiences in images.",
    clickToEnlarge: "Click to enlarge",
    filters: {
      all: "All",
      exterior: "Exteriors",
      rooms: "Interiors",
      amenities: "Amenities"
    }
  },
  notFound: {
    title: "Page Not Found",
    description: "The page you are looking for does not exist or has been moved.",
    returnHome: "Return Home"
  },
  apartments: {
    title: "Our Properties",
    subtitle: "Discover our portfolio of prestigious villas and apartments.",
    filters: {
      guests: "Guests",
      anyGuests: "Any",
      location: "Location",
      allLocations: "All",
      priceRange: "Price",
      showing: "Showing",
      of: "of",
      accommodations: "properties",
      resetFilters: "Reset",
      noMatch: "No properties match your criteria",
      adjustFilters: "Try adjusting your filters.",
      viewDetails: "View",
      features: "features",
      more: "more",
      persons: "persons",
      searchPlaceholder: "Search by name or location...",
      region: "Region",
      allRegions: "All regions",
      sortBy: "Sort by",
      sortDefault: "Default",
      sortPriceAsc: "Price (low → high)",
      sortPriceDesc: "Price (high → low)",
      sortCapacityDesc: "Capacity (max → min)",
      sortCapacityAsc: "Capacity (min → max)",
      sortSizeDesc: "Area (max → min)",
      sortSizeAsc: "Area (min → max)",
      allPrices: "All prices",
      upTo: "Up to",
      moreThan: "More than",
      gridView: "Grid view",
      listView: "List view"
    }
  },
  apartmentDescriptions: {
    "1": { 
      name: "Villa Azure", 
      description: "Exceptional beachfront villa",
      longDescription: "Perched on the cliffs of Cap d'Antibes, Villa Azure offers breathtaking panoramic views of the Mediterranean. This architectural masterpiece combines Provençal elegance with modern luxury, featuring 6 en-suite bedrooms, an infinity pool, and private beach access.",
      features: ["Infinity pool", "Private beach", "Home cinema", "Wine cellar", "Chef's kitchen", "Spa & sauna"],
      highlights: ["Direct sea access", "360° panoramic views", "Landscaped gardens"]
    },
    "2": { 
      name: "Château Provence", 
      description: "Historic Provençal estate",
      longDescription: "A magnificent 17th-century château nestled in the Luberon hills. This exceptional estate spans 15 hectares of lavender fields and olive groves, offering a unique blend of historic charm and contemporary comfort.",
      features: ["Heated pool", "Tennis court", "Orangery", "Chapel", "Guest house", "Organic garden"],
      highlights: ["15 hectares of grounds", "Historic architecture", "Vineyard"]
    },
    "3": { 
      name: "Palais Cannes", 
      description: "Ultra-luxury penthouse",
      longDescription: "Located on the prestigious Croisette, this exceptional penthouse offers unobstructed views of the Bay of Cannes and the Lérins Islands. 450m² of refined living space with rooftop terrace and private pool.",
      features: ["Rooftop pool", "Private elevator", "Home automation", "Wine room", "Fitness room", "Concierge 24/7"],
      highlights: ["Croisette location", "Panoramic bay views", "Festival access"]
    },
    "4": { 
      name: "Villa Méditerranée", 
      description: "Contemporary villa with sea views",
      longDescription: "A contemporary architectural gem in the heights of Saint-Jean-Cap-Ferrat. Clean lines and floor-to-ceiling windows frame stunning views of the Mediterranean. Pool with infinity edge and lush Mediterranean garden.",
      features: ["Infinity pool", "Pool house", "Designer kitchen", "Smart home", "Electric car charger", "Outdoor kitchen"],
      highlights: ["Contemporary architecture", "Unobstructed sea views", "Prime location"]
    },
    "5": { 
      name: "Bastide Provençale", 
      description: "18th century bastide",
      longDescription: "An authentic 18th-century bastide meticulously restored in the heart of Provence. This property combines period charm with modern amenities, surrounded by 5 hectares of parkland with centuries-old trees.",
      features: ["Pool & pool house", "Pétanque court", "Summer kitchen", "Stone fireplace", "Cellar", "Caretaker's house"],
      highlights: ["Authentic charm", "5 hectares of parkland", "Total tranquility"]
    },
    "6": { 
      name: "Villa Port Grimaud", 
      description: "Venetian villa on the water",
      longDescription: "In the heart of the lacustrine city of Port Grimaud, this exceptional villa opens onto the canals and the Mediterranean. Venetian architecture, private pontoon and breathtaking views of the Gulf of Saint-Tropez.",
      features: ["Private pontoon", "Direct sea access", "Waterfront terrace", "Boat garage", "Gulf views", "Mediterranean garden"],
      highlights: ["Unique lacustrine city", "Minutes from Saint-Tropez", "Venetian charm"]
    },
    "7": { 
      name: "Villa Tropézienne", 
      description: "Legendary Saint-Tropez villa",
      longDescription: "Iconic villa overlooking the Gulf of Saint-Tropez. This legendary property has hosted stars and royalty, offering 12 bedrooms, infinity pool with pool house, and direct access to Pampelonne beach.",
      features: ["Infinity pool", "Pool house", "Private beach access", "Home cinema", "Professional kitchen", "Gym"],
      highlights: ["Gulf of Saint-Tropez views", "Pampelonne beach", "Star legacy"]
    },
    "8": { 
      name: "Mas des Oliviers", 
      description: "Authentic Provençal mas",
      longDescription: "A charming 19th-century mas nestled among olive groves and lavender fields. This authentic property has been lovingly restored to offer modern comfort while preserving its Provençal soul. 8 bedrooms, heated pool.",
      features: ["Heated pool", "Olive grove", "Summer kitchen", "Pétanque court", "Wine cellar", "Landscaped garden"],
      highlights: ["Provençal authenticity", "100-year-old olive trees", "Absolute serenity"]
    },
    "9": { 
      name: "Appartement Palais Maeterlinck", 
      description: "Prestigious Nice apartment",
      longDescription: "Exceptional apartment in the legendary Palais Maeterlinck, former residence of the Nobel Prize laureate. 280m² with sea views, access to private beach, heated pool and spa of the residence.",
      features: ["Private beach", "Heated pool", "Spa", "Concierge", "Secure parking", "Sea terrace"],
      highlights: ["Historic palace", "180° sea view", "5-star services"]
    },
    "10": { 
      name: "Villa Cap Ferrat", 
      description: "Exceptional Cap Ferrat estate",
      longDescription: "One of the last remaining properties on the prestigious Cape. This exceptional villa offers 180° views of the Mediterranean, 3 hectares of landscaped gardens, Olympic-sized pool and private helipad.",
      features: ["Olympic pool", "Helipad", "Staff quarters", "Tennis court", "Private dock", "Tropical garden"],
      highlights: ["Unique location", "Total privacy", "Ultimate prestige"]
    },
    "11": { 
      name: "Loft Vieux Nice", 
      description: "Designer loft Old Nice",
      longDescription: "Exceptional 350m² loft in a renovated 18th-century building. This unique space combines historic charm with contemporary design, featuring a private rooftop terrace with panoramic views of Nice.",
      features: ["Rooftop terrace", "Designer kitchen", "High ceilings", "Smart home", "Secure parking", "Wine cellar"],
      highlights: ["Historic charm", "Panoramic views", "Central location"]
    },
    "12": { 
      name: "Domaine Sainte-Victoire", 
      description: "Estate facing Sainte-Victoire",
      longDescription: "Exceptional estate at the foot of Sainte-Victoire mountain, Cézanne's inspiration. 20 hectares of vineyards and olive trees, main house with 10 bedrooms, 2 guest houses, and wine cellar with annual production.",
      features: ["Working vineyard", "Olive grove", "Infinity pool", "Guest houses", "Private cellar", "Equestrian facilities"],
      highlights: ["Cézanne views", "Wine production", "Exceptional estate"]
    },
    "13": { 
      name: "Villa Èze", 
      description: "Mediterranean eagle's nest",
      longDescription: "Perched in the medieval village of Èze, this exceptional villa offers dizzying views of the Mediterranean. Tastefully renovated Provençal architecture, terraced gardens, and a pool suspended between sky and sea.",
      features: ["Panoramic pool", "Terraced gardens", "Vaulted cellar", "Rooftop terrace", "Hammam", "Secure garage"],
      highlights: ["Hilltop village", "270° views", "Medieval atmosphere"]
    },
    "14": { 
      name: "Bastide des Alpilles", 
      description: "Bastide in the heart of the Alpilles",
      longDescription: "Majestic 19th-century bastide nestled in the Alpilles natural park. Surrounded by centuries-old olive trees and cypresses, this 8-hectare property combines Provençal charm with luxury amenities.",
      features: ["18m heated pool", "Tennis court", "Organic olive grove", "Pool house", "Caretaker's house", "Vegetable garden"],
      highlights: ["Alpilles natural park", "8 private hectares", "Preserved authenticity"]
    },
    "15": { 
      name: "Penthouse Croisette", 
      description: "Penthouse Festival views",
      longDescription: "On the top floor of an Art Deco residence on La Croisette, this 400m² penthouse overlooks the Palais des Festivals. Panoramic terrace with jacuzzi, interiors designed by a renowned architect.",
      features: ["150m² terrace", "Outdoor jacuzzi", "Private elevator", "Full home automation", "24h concierge", "2 parking spaces"],
      highlights: ["Facing Palais des Festivals", "Architect design", "Bay of Cannes views"]
    },
    "16": { 
      name: "Mas de Gordes", 
      description: "Artist's mas in Gordes",
      longDescription: "Former artist's mas in the classified village of Gordes. This characterful property has preserved its authenticity with exposed stone, antique beams, and terracotta tiles, while offering high-end contemporary comfort.",
      features: ["Natural pool", "Artist's studio", "Summer kitchen", "Shaded terraces", "Wine cellar", "Provençal garden"],
      highlights: ["Classified village", "Artistic character", "Luberon valley views"]
    },
    "17": { 
      name: "Villa Beaulieu-sur-Mer", 
      description: "Belle Époque villa Beaulieu",
      longDescription: "Sumptuous Belle Époque villa on the Beaulieu seafront. This historic residence has been meticulously restored, combining period moldings with modern comfort. Direct sea access and private dock.",
      features: ["Direct sea access", "Private dock", "Seawater pool", "Music room", "Orangery", "French gardens"],
      highlights: ["Belle Époque architecture", "Seafront", "History & prestige"]
    },
    "18": { 
      name: "Château Mougins", 
      description: "Contemporary château Mougins",
      longDescription: "Reinvented château in the heart of Mougins, the gastronomes' village. Bold contemporary architecture integrated into 4 hectares of Mediterranean parkland. Wellness area, reception room, and helipad.",
      features: ["Full spa", "Reception room", "Helipad", "Collection cellar", "Tennis", "Staff quarters"],
      highlights: ["Gastronomic village", "Unique architecture", "4 hectares of parkland"]
    },
    "19": { 
      name: "Appartement Port Hercule", 
      description: "Apartment Port Hercule views",
      longDescription: "Rare 320m² apartment with terrace overlooking Monaco's legendary Port Hercule. Exceptional location for the Grand Prix and nautical events. Prestigious finishes and luxury residence services.",
      features: ["80m² terrace", "Port & Palace views", "Double parking", "Wine cellar", "Beach access", "Concierge"],
      highlights: ["Grand Prix views", "Port Hercule", "Iconic location"]
    },
    "20": { 
      name: "Domaine Valbonne", 
      description: "Equestrian estate Valbonne",
      longDescription: "Exceptional equestrian estate in the Cannes hinterland. 15 hectares with covered arena, 12-box stables, main house, and 2 outbuildings. Preserved setting among olive trees and centuries-old oaks.",
      features: ["Covered arena", "12 boxes", "Olympic arena", "Heated pool", "2 outbuildings", "Private forest"],
      highlights: ["Equestrian estate", "15 wooded hectares", "Absolute privacy"]
    },
    "21": { 
      name: "Villa Sainte-Victoire", 
      description: "Charming villa with Sainte-Victoire views",
      longDescription: "Charming villa with pool and panoramic views of Sainte-Victoire mountain, near Lake Bimont and Aix-en-Provence city centre. 5 bedrooms, 2 living rooms, 3 terraces for unforgettable stays in Provence.",
      features: ["Pool with Sainte-Victoire views", "5 bedrooms", "2 living rooms", "3 terraces", "Large garden", "Private parking", "Air conditioning", "Hiking accessible"],
      highlights: ["Sainte-Victoire views", "Near Lake Bimont", "5 spacious bedrooms"]
    },
    "22": { 
      name: "Bastide Aix Centre", 
      description: "19th-century bastide with pool in city centre",
      longDescription: "Charming villa with pool and panoramic city views in the heart of Aix-en-Provence. Former 19th-century guard house, 1000m² garden. Ideal for discovering Aix-en-Provence and Provence.",
      features: ["Pool", "Panoramic city views", "3 suites", "1000m² garden", "City centre 2 min", "Air conditioning", "Terraces", "Private parking"],
      highlights: ["Aix city centre", "Historic 19th-century building", "1000m² garden"]
    },
    "23": { 
      name: "Apartment Aix Centre", 
      description: "Bright apartment with Cathedral views",
      longDescription: "Charming 40m² bright apartment on the 3rd floor with views of Saint-Sauveur Cathedral and the rooftops of the historic centre. 200m from City Hall, south-facing balcony.",
      features: ["Cathedral views", "5m² south-facing balcony", "Equipped kitchen", "Washing machine", "Nespresso machine", "Air conditioning", "Double bed", "City centre 200m", "Quiet area"],
      highlights: ["Saint-Sauveur Cathedral views", "Historic city centre", "South-facing balcony"]
    },
    "24": { 
      name: "Villa Cap d'Antibes", 
      description: "Mediterranean villa with panoramic sea views",
      longDescription: "Sumptuous Mediterranean villa with infinity pool and panoramic sea views. Private access to coves, 2000m² landscaped garden. 6 luxurious bedrooms on Cap d'Antibes.",
      features: ["Infinity pool", "Panoramic sea views", "6 bedrooms", "5 bathrooms", "Private beach access", "2000m² garden", "Summer kitchen", "Air conditioning", "Parking for 4 vehicles"],
      highlights: ["Cap d'Antibes", "180° sea views", "Private cove access"]
    },
    "25": { 
      name: "Mas du Luberon", 
      description: "Golden stone mas in the heart of the Luberon",
      longDescription: "Authentic golden stone mas in the heart of the Luberon. Pool surrounded by lavender, centuries-old olive grove and views of the Provençal hills. 4 bedrooms for an authentic Provençal stay.",
      features: ["Heated pool", "Lavender fields", "4 bedrooms", "3 bathrooms", "Olive grove", "Shaded terrace", "Provençal kitchen", "Air conditioning", "Parking"],
      highlights: ["Heart of the Luberon", "Authentic golden stone", "Lavender fields"]
    },
    "26": { 
      name: "Apartment Saint-Tropez", 
      description: "Designer apartment in the heart of Saint-Tropez",
      longDescription: "Elegant contemporary apartment in the heart of Saint-Tropez. Luxurious design with walnut-fitted kitchen, private terrace and high-end finishes. Minutes from the beaches.",
      features: ["Designer kitchen", "Private terrace", "2 bedrooms", "1 bathroom", "Air conditioning", "Chevron parquet", "Near beaches", "City centre 5 min"],
      highlights: ["Heart of Saint-Tropez", "Contemporary design", "Private terrace"]
    },
    "27": { 
      name: "A-Frame Cabin", 
      description: "Unique A-frame cabin with jacuzzi in Provence",
      longDescription: "Unique A-frame cabin with private jacuzzi and wooden terrace. A one-of-a-kind experience in the heart of Provençal nature, ideal for a romantic getaway.",
      features: ["Private jacuzzi", "Wooden terrace", "1 bedroom", "Nature views", "Air conditioning", "King-size bed", "Equipped kitchen", "Thermal insulation"],
      highlights: ["Unique A-Frame architecture", "Private jacuzzi", "Provençal nature"]
    },
    "28": {
      name: "Villa Vauvenargues",
      description: "Charming villa at the foot of Sainte-Victoire mountain",
      longDescription: "Charming villa at the foot of Sainte-Victoire mountain, in Picasso's beloved village. Pool, Mediterranean garden and stunning mountain views.",
      features: ["Pool", "4 bedrooms", "3 bathrooms", "Sainte-Victoire views", "Mediterranean garden", "Air conditioning", "Terrace", "Private parking", "Fireplace"],
      highlights: ["Picasso's village", "Sainte-Victoire views", "Mediterranean garden"]
    },
    "29": {
      name: "Bastide Auriol",
      description: "Provençal bastide in the Garlaban hills",
      longDescription: "Provençal bastide in the Garlaban hills, Marcel Pagnol's homeland. Pool, olive grove and absolute tranquility in the heart of authentic Provence.",
      features: ["Pool", "3 bedrooms", "2 bathrooms", "Hill views", "Olive grove", "Air conditioning", "Shaded terrace", "Parking", "Barbecue"],
      highlights: ["Garlaban hills", "Pagnol country", "Absolute tranquility"]
    }
  },
  booking: {
    accommodationSelect: { continue: "Continue" },
    summary: { night: "night", nights: "nights" }
  },
  bookingForm: {
    title: "Free Estimate",
    propertyType: "Property Type",
    selectPropertyType: "Select",
    villa: "Villa",
    apartment: "Apartment",
    house: "House",
    penthouse: "Penthouse",
    location: "Location",
    selectLocation: "Select city",
    cannes: "Cannes",
    nice: "Nice",
    saintTropez: "Saint-Tropez",
    antibes: "Antibes",
    monaco: "Monaco",
    marseille: "Marseille",
    aixEnProvence: "Aix-en-Provence",
    other: "Other",
    surface: "Surface (sqm)",
    surfacePlaceholder: "Ex: 150",
    bedrooms: "Bedrooms",
    bathrooms: "Bathrooms",
    amenities: "Amenities",
    pool: "Pool",
    panoramicView: "Panoramic View",
    waterfront: "Waterfront",
    garden: "Garden",
    parking: "Parking",
    airConditioning: "Air Conditioning",
    firstName: "First Name",
    firstNamePlaceholder: "Your first name",
    lastName: "Last Name",
    lastNamePlaceholder: "Your last name",
    email: "Email",
    emailPlaceholder: "your@email.com",
    phone: "Phone",
    phonePlaceholder: "+33 6 00 00 00 00",
    address: "Address",
    addressPlaceholder: "Property address",
    checkAvailability: "Get Estimate",
    bookingConfirmed: "Request Sent!"
  },
  estimation: {
    subtitle: "Property Management",
    title: "Discover Your Property's Potential",
    description: "Get a free estimate of your property's rental potential.",
    progress: "Progress",
    benefits: {
      freeEstimate: "Free estimate",
      revenueOptimization: "Revenue optimization",
      turnkeyManagement: "Turnkey management",
      insuranceIncluded: "Insurance included"
    }
  },
  travelerSearch: {
    subtitle: "Travelers",
    title: "Find Your Ideal Stay",
    description: "Describe your wishes and our team will offer a personalized selection matching your criteria.",
    benefits: {
      response24h: "Response within 24h",
      personalizedSelection: "Personalized selection",
      noBookingFees: "No booking fees",
      dedicatedAdvisor: "Dedicated advisor"
    },
    destination: "Destination",
    selectDestination: "Select",
    destinations: {
      aixEnProvence: "Aix-en-Provence",
      luberon: "Luberon",
      alpilles: "Alpilles",
      gordes: "Gordes",
      coteDAzur: "French Riviera",
      saintTropez: "Saint-Tropez",
      other: "Other"
    },
    arrivalDate: "Arrival",
    departureDate: "Departure",
    selectDate: "Select",
    guests: "Guests",
    selectGuests: "Number",
    propertyType: "Property type",
    selectPropertyType: "Any",
    propertyTypes: {
      villa: "Villa",
      apartment: "Apartment",
      mas: "Mas / Bastide",
      any: "Any"
    },
    budget: "Budget / night",
    selectBudget: "Optional",
    budgets: {
      under200: "Under €200",
      from200to500: "€200 - €500",
      from500to1000: "€500 - €1,000",
      over1000: "Over €1,000"
    },
    firstName: "First name",
    firstNamePlaceholder: "Your first name",
    email: "Email",
    emailPlaceholder: "your@email.com",
    phone: "Phone",
    phonePlaceholder: "+33 6 00 00 00 00",
    message: "Preferences / Message",
    messagePlaceholder: "E.g.: sea view, pool, close to city center...",
    submit: "Send my request",
    submitting: "Sending...",
    submitted: "Request sent!",
    progress: "Progress"
  },
  contactProfiles: {
    selectProfile: "Click to choose your profile",
    traveler: "Traveler",
    travelerDesc: "I'm looking for accommodation",
    owner: "Owner",
    ownerDesc: "I'd like an estimate",
    other: "Other",
    otherDesc: "Other inquiry",
    yourCoordinates: "Your Details",
    howCanWeHelp: "How can we help you?",
    sendTheMessage: "Send message",
    otherBenefits: ["Response within 24h", "Team at your service", "No commitment"]
  },
  blog: {
    subtitle: "Blog",
    title: "Tips & News",
    description: "Stay informed with the latest trends, tips, and insights from luxury property management experts on the French Riviera.",
    backToBlog: "← Back to Blog",
    readMore: "Read More",
    featured: "Featured",
    noArticles: "No articles found for this category.",
    ctaTitle: "Ready to Maximize Your Property's Potential?",
    ctaDescription: "Get your free property analysis and discover how our professional management services can increase your rental income.",
    ctaButton: "Request Free Estimate"
  },
  home: {
    welcome: { subtitle: "Welcome", title: "High-End Services", description1: "Exceptional services tailored to your lifestyle.", description2: "We anticipate your every desire.", learnMore: "Learn More" },
    booking: { subtitle: "Estimate", title: "Discover Your Property's Potential", description: "Get a free estimate of your rental income.", benefits: ["Free estimate", "Revenue optimization", "Turnkey management"] },
    featuredApartments: { subtitle: "Portfolio", title: "Featured Properties", description: "A curated selection of exceptional properties.", viewAll: "View All" },
    amenities: {
      subtitle: "Services",
      title: "Our Expertise",
      description: "A thoughtful range of services designed around your needs.",
      features: {
        beachfront: { title: "Beachfront Properties", description: "Exclusive villas with direct beach access." },
        pools: { title: "Private Pools", description: "Infinity pools overlooking the Mediterranean." },
        restaurant: { title: "Private Chefs", description: "Gastronomic experiences at home." },
        wifi: { title: "Smart Homes", description: "Cutting-edge technology for maximum comfort." },
        bar: { title: "Wine Cellars", description: "Curated selections of fine wines." },
        location: { title: "Prime Locations", description: "The most prestigious addresses on the Riviera." }
      }
    },
    cta: { title: "Ready for the Exceptional?", description: "Contact us to discover our services.", bookNow: "Contact Us" },
    location: {
      basedIn: "Concierge based in",
      partnerNetwork: "Partner network",
      withPartner: "with",
      estimateCta: "Request an estimate",
      bookCta: "Book accommodation",
      servicesDescription: "Based in Aix-en-Provence, we operate directly across the Aix area and collaborate with partner concierges throughout Provence & the French Riviera.",
      leadFormDescription: "Traveler, owner or just curious — tell us about your needs and receive a personalized response within 24h.",
      available7days: "Available 7 days a week",
      noCommitment: "No commitment",
      response24h: "Response within 24h",
      anotherQuestion: "Another question?"
    },
    badges: { exclusive: "Exclusive", new: "New", favorite: "Favorite", atypical: "Unique" },
    blogSection: { subtitle: "Blog", title: "Tips & News", description: "Explore our articles to optimize the rental and management of your property.", viewAll: "See all articles", readMore: "Read article", filterAll: "All" }
  },
  amenitiesPage: {
    title: "Our Services",
    subtitle: "Services Tailored to You",
    description: "Discover our complete range of luxury services designed for the most demanding clients.",
    categories: {
      wellness: { title: "Wellness & Spa", description: "Rejuvenate body and mind with our wellness partners.", items: ["In-villa spa treatments", "Personal trainers", "Yoga instructors", "Beauty therapists"] },
      dining: { title: "Fine Dining", description: "Exceptional culinary experiences.", items: ["Private chefs", "Catering services", "Wine sommelier", "Starred restaurant reservations"] },
      services: { title: "Concierge Services", description: "24/7 assistance for all your needs.", items: ["VIP transfers", "Personal shopping", "Event planning", "Travel coordination"] },
      entertainment: { title: "Entertainment", description: "Exclusive experiences and activities.", items: ["Yacht charters", "Supercar rentals", "VIP event access", "Private tours"] }
    }
  },
  servicePages: {
    offer: {
      sectionLabel: "Our packages",
      sectionTitle: "Our offer",
      sectionDescription: "Our all-inclusive package handles your property from A to Z. À la carte services remain available for owners who manage their own bookings.",
      main: {
        badge: "OUR CORE BUSINESS",
        title: "Our \"Complete Management\" all-inclusive package",
        subtitle: "Seasonal rental management from A to Z.",
        price: "20%",
        priceUnit: "of net rental income",
        priceNote: "A single commission, only charged when your property is rented.",
        intro: "No entry fee, no subscription, no extra service charge. Cleaning, laundry, guest welcome, maintenance and follow-up are included in the commission.",
        leftHighlights: [
          "Success-based commission — you pay nothing until your property is rented",
          "No application, set-up or subscription fees",
          "No minimum commitment period",
          "Professional cleaning and laundry included with every changeover"
        ],
        rightHighlights: [
          "International multi-platform distribution (Airbnb, Abritel, Booking, Expedia, Hotels.com…)",
          "Guest welcome, maintenance and assistance 7 days a week",
          "A strategy built for your property: seasonal only, or hybrid with mobility lease",
          "Commission reduced to 10% on lets longer than three months"
        ],
        cta: "Discover Complete Management"
      },
      secondary: {
        title: "À la carte services",
        subtitle: "CLEANING, LINEN AND CONSUMABLES",
        price: "From €55",
        priceUnit: "per changeover",
        intro: "You manage your own bookings and want to delegate on-site operations.",
        priceRows: [
          { label: "Cleaning between stays", price: "from €55" },
          { label: "Linen, per bed made up", price: "€10 to €20" },
          { label: "Consumables", price: "€12 per changeover" }
        ],
        highlights: [
          "No commission on your income",
          "No minimum commitment period",
          "Monthly billing",
          "Insured and vetted providers"
        ],
        cta: "See the price list"
      },
      includedTitle: "Included at no extra cost",
      included: [
        { title: "Drone video shoot", description: "Indoors and outdoors, produced in-house. Your listing stands out from the very first thumbnail." },
        { title: "Direct booking channel", description: "A dedicated page for your property on our website. No service fees, no additional commission." },
        { title: "Active property promotion", description: "Instagram, Facebook, LinkedIn, TikTok and Google Ads campaigns. We go and find the guests." }
      ],
      hybrid: {
        label: "Tailored strategy",
        title: "Seasonal in high season, mobility lease in low season",
        description: "We build a rental strategy suited to the actual characteristics of your property. In Aix-en-Provence, the hybrid strategy lets your home generate income twelve months a year while remaining under your control.",
        cta: "Discover the hybrid strategy"
      }
    },
    learnMore: "Learn more",
    gestionLocative: {
      seoTitle: "Property Management Aix-en-Provence | All-Inclusive 20% Package",
      seoDescription: "Seasonal rental management in Aix-en-Provence. All-inclusive package at 20% of net rental income: drone shoot, multi-platform distribution, cleaning and laundry included, guest welcome, maintenance, hybrid mobility-lease strategy. Free estimate.",
      heroTitle: "Property Management in Aix-en-Provence",
      heroSubtitle: "Property Management",
      heroDescription: "Trust Conciergerie Cabassol with your property. For 20% of net rental income, we handle the entire operation: from the photo shoot to the guest welcome, from cleaning to income reporting. We work with a limited number of owners to give each one the attention they deserve.",
      sections: [
        {
          title: "A simple commitment, a complete service",
          description: "For 20% of net rental income, all our services are included. No set-up fee, no onboarding fee, no extra charge when a guest arrives.",
          features: [
            "20% of net rental income, with no additional fees",
            "Professional cleaning and laundry included with every booking",
            "Thorough property preparation before each arrival",
            "Consumables: €10 per booking, purchase and replenishment included",
            "No minimum commitment period"
          ]
        },
        {
          title: "Marketing and visibility",
          description: "Your property deserves to be presented with care. We craft each listing to reflect its real quality and attract the guests that suit it.",
          features: [
            "Professional photo and drone video shoot, retouching included",
            "Listing copywriting and search optimisation on the platforms",
            "Styling guidance and furnishing recommendations",
            "Promotion on Instagram, Facebook, LinkedIn, TikTok and through Google Ads campaigns"
          ]
        },
        {
          title: "International multi-platform distribution",
          description: "One listing, one point of contact, maximum visibility. Your calendar is permanently synchronised: no risk of double bookings.",
          features: [
            "Airbnb",
            "Booking.com",
            "Abritel and the Expedia network: Vrbo, Expedia, Hotels.com",
            "Your direct booking channel, hosted on our website, with no service fee or additional commission"
          ]
        },
        {
          title: "Tailored rental strategy",
          description: "Not every property rents the same way. We build your yearly calendar from your location, layout and the seasonality actually observed: seasonal all year, or a hybrid strategy with a mobility lease in low season.",
          features: [
            "Analysis of your property's real seasonality",
            "Choice between seasonal-only and hybrid strategy",
            "Mobility lease of 1 to 10 months during quiet months, your property stays free for the summer",
            "Commission reduced to 10% on any continuous let longer than three months"
          ]
        },
        {
          title: "Pricing and reporting",
          description: "Your rates follow the Aix market, not an annual review.",
          features: [
            "Local market analysis and price adjustments by season, demand and local events",
            "Guest and owner calendar management, including blocking your personal dates",
            "Payment and invoice tracking",
            "Regular reports on your income and occupancy rate"
          ]
        },
        {
          title: "Administrative assistance",
          description: "We support you through your formalities and flag what falls to you.",
          features: [
            "Help with your administrative formalities",
            "Drafting of rental contracts: seasonal leases, mobility leases, student leases",
            "Guest registration form and collection of ID documents",
            "Compliance and safety advice, notably on regulated equipment"
          ]
        },
        {
          title: "Welcome, inspections and upkeep",
          description: "Every changeover follows the same protocol, checked room by room.",
          features: [
            "On-site welcome or self check-in via key box, depending on the property and arrival time",
            "Presentation of the property and how everything works",
            "Check-in and check-out inspections on direct bookings, with photographic evidence",
            "Regular inventory of furniture and equipment",
            "Hotel-standard professional cleaning after every departure",
            "Washing, drying and hotel-standard bed preparation at every changeover",
            "Consumables replenishment"
          ]
        },
        {
          title: "Handling the unexpected",
          description: "A problem during a stay should never become yours.",
          features: [
            "Emergency call-outs: locksmith, plumbing, electricity, pest control",
            "Handling guest disputes and damage to the property or equipment",
            "Replacement of damaged items, funded by the deposit or insurance",
            "Assistance and maintenance 7 days a week"
          ]
        },
        {
          title: "Online reputation",
          description: "Guest reviews build the rental value of your property. We give them the time they deserve.",
          features: [
            "A personalised reply to every review",
            "Feedback requests to satisfied guests",
            "Rating monitoring and corrective action"
          ]
        },
        {
          title: "Guest services",
          description: "A successful stay produces a good review, and a good review produces the next booking.",
          features: [
            "Restaurant, market and local address recommendations, tailored to each guest",
            "Activities and experiences across Provence",
            "Coordination of special requests",
            "Welcome in French and English"
          ]
        }
      ],
      extras: {
        title: "Complementary services",
        items: [
          "Pool and spa maintenance",
          "Garden upkeep",
          "Deep clean or end-of-season clean",
          "Creation of your property's direct booking page"
        ]
      },
      advantages: {
        title: "Why seasonal rental",
        items: [
          "Generally higher returns than a traditional let",
          "Payment is settled at the time of booking",
          "A commission calculated only on income actually generated",
          "Pricing flexibility based on supply and demand",
          "The freedom to take back your property or stay in it whenever you wish"
        ]
      },
      advantageBadges: [
        "Cleaning and linen included",
        "Payment at booking",
        "Success-based fee",
        "Hybrid mobility-lease strategy",
        "Social media & Google Ads promotion",
        "Direct booking channel"
      ],
      ctaTitle: "Estimate Your Property's Potential",
      ctaDescription: "Get a free estimate of your rental income and discover what our support can bring to your property.",
      ctaButton: "Request a free estimate",
      homeKeyPoints: [
        "Professional photo and drone video shoot",
        "Airbnb, Booking, Abritel, Vrbo, Expedia distribution",
        "Cleaning and laundry included",
        "Hybrid seasonal / mobility-lease strategy"
      ]
    },
    aLaCarte: {
      seoTitle: "À la carte services Aix-en-Provence | Cleaning, linen and consumables",
      seoDescription: "Changeover cleaning, linen and consumables for your seasonal rental in Aix-en-Provence. No commission, no commitment: cleaning from €55 per changeover, linen from €10, consumables €12 per changeover.",
      heroTitle: "À la carte services",
      heroSubtitle: "No commission",
      heroDescription: "Cleaning, linen and consumables. You handle your own bookings and want to delegate the on-site work. Our services are bought per intervention: no commission on your income, no commitment period.",
      cleaning: {
        title: "Cleaning between stays",
        columns: ["Property type", "Surface", "Per changeover"],
        rows: [
          ["Studio or 1-bed", "up to 35 m²", "€55"],
          ["2-room", "35 to 60 m²", "€70"],
          ["3-room", "60 to 90 m²", "€85"],
          ["4-room", "90 to 120 m²", "€100"],
          ["House or villa", "120 m² and above", "On quote, from €130"]
        ],
        includesTitle: "Every intervention includes:",
        includes: [
          "Floors vacuumed and washed, full dusting of furniture and surfaces",
          "Kitchen: worktops, sink, hob, fridge, microwave, coffee machine, cupboard fronts",
          "Bathroom and toilets: shower, basin, taps, mirrors, drains",
          "Interior windows, handles and contact points",
          "Bins emptied and bags replaced",
          "Check for forgotten items, including under the beds",
          "Room-by-room photographs after the intervention",
          "Immediate reporting of any anomaly or damage"
        ]
      },
      linen: {
        title: "Linen",
        columns: ["", "Per changeover"],
        rows: [
          ["Double bed", "€20"],
          ["Single bed", "€10"]
        ],
        note: "The rate applies per bed actually prepared and includes the bath linen for the occupants of that bed. The linen remains the owner's.",
        items: [
          "Clean linen delivered to the property",
          "Hotel-standard bed preparation",
          "Collection of used bed and bath linen",
          "Washing and drying",
          "Folding and return to storage in the property"
        ]
      },
      consumables: {
        title: "Consumables",
        price: "€12 per changeover",
        description: "No more shopping and no more shortages. Quantities are calibrated per stay and you only pay for stays that actually take place.",
        detail: "Coffee, tea, sugar, salt, pepper, olive oil, toilet paper, kitchen roll, shower gel, shampoo, hand soap, laundry detergent, washing-up liquid, bin bags and everyday cleaning products. Purchase, delivery and replenishment included."
      },
      complementary: {
        title: "Complementary services",
        items: [
          "Pool and spa maintenance",
          "Garden upkeep",
          "Deep clean or end-of-season clean",
          "Creation of your property's direct booking page"
        ]
      },
      conditions: {
        title: "Conditions",
        items: [
          "Interventions to be booked at least 48 hours in advance",
          "Minimum of two interventions per month",
          "Cleaning equipment and products available in the property",
          "Monthly invoicing, payment within 15 days",
          "€10 travel supplement for Vauvenargues and Saint-Marc-Jaumegarde",
          "Time slots are allocated subject to availability, with priority given to properties under complete management"
        ]
      },
      crossSell: {
        title: "Would you rather delegate everything?",
        description: "Our Complete Management package covers the listing, pricing, bookings, guest welcome and day-to-day operation, for 20% of net rental income. Cleaning and linen are paid directly by the guests: you never advance a cent.",
        cta: "Discover Complete Management"
      },
      ctaTitle: "A quote for your property",
      ctaDescription: "Tell us your property's surface area and number of beds: we reply within 24 hours.",
      ctaButton: "Request a quote"
    },
    bailMobilite: {
      seoTitle: "Mobility lease Aix-en-Provence | Hybrid seasonal rental strategy",
      seoDescription: "Mobility lease in Aix-en-Provence: seasonal rental in high season, mobility lease of 1 to 10 months in low season. Full lease management, Visale application, tenant selection. 10% commission beyond three months.",
      heroTitle: "Mobility lease in Aix-en-Provence: stop letting your property sleep through winter",
      heroSubtitle: "Hybrid strategy",
      heroDescription: "Aix lives by its seasons. From June to September, festivals, visitors and families fill the properties. For the rest of the year, many owners watch their calendar empty. The hybrid strategy solves this: seasonal rental in high season, mobility lease during the quiet months. Your property works twelve months a year, without ever being taken away from you for good.",
      sections: [
        {
          title: "What the mobility lease is",
          description: "Created by the 2018 ELAN law, the mobility lease is a furnished rental contract of one to ten months, non-renewable, reserved for tenants in a temporary situation: studies, internship, apprenticeship, professional training, temporary assignment, transfer or civic service, with supporting documents.",
          features: [
            "No automatic renewal: the lease ends on its date, with no notice to give and no procedure to start",
            "No security deposit may be requested, the law forbids it. The Visale guarantee from Action Logement replaces it, free of charge, and covers unpaid rent and damage",
            "The tenant can leave with one month's notice, you cannot: that is the counterpart of the flexibility"
          ]
        },
        {
          title: "A lighter regulatory framework",
          description: "Unlike a tourist rental, the mobility lease requires neither registration with the town hall nor a change-of-use authorisation. As seasonal rental regulation tightens, this flexibility gives you a second leg to stand on, ready to activate if the rules change in your municipality.",
          features: []
        },
        {
          title: "Who rents on a mobility lease in Aix",
          description: "Demand is real and documented by the local landscape. These tenants look for a ready-to-live furnished home, for a set period, in a well-connected area. That is exactly what your seasonal property already offers.",
          features: [
            "Students from Aix-Marseille University, Sciences Po Aix and the city-centre graduate schools",
            "Interns and apprentices on three- to six-month assignments",
            "Hospital residents and staff on temporary posts",
            "Employees on transfer or assignment, while they look for permanent housing",
            "Visiting researchers and lecturers"
          ]
        },
        {
          title: "How we proceed",
          description: "Five steps, from the initial assessment to the seasonal handover.",
          features: [
            "Assessment of your property: location, layout, equipment, the seasonality actually observed. Not every property suits the hybrid approach, and we will tell you frankly",
            "Building the yearly calendar: the seasonal window to preserve and the window to open to the mobility lease",
            "Finding and selecting the tenant: distribution, verification of eligibility documents, Visale application",
            "Drafting the lease and its annexes, check-in and check-out inspections",
            "Follow-up during the tenancy and restoration for the seasonal handover"
          ]
        },
        {
          title: "Our commission",
          description: "On any continuous let longer than three months, including mobility leases, our commission drops from 20% to 10% of rental income. Management requires fewer changeovers: it is only fair that you benefit.",
          features: []
        },
        {
          title: "The limits, stated frankly",
          description: "The mobility lease is not a universal solution, and it is better to know beforehand. We secure each of these points in the file we build.",
          features: [
            "The monthly rent is lower than the same property would earn in full seasonal use. It is, however, guaranteed and free of changeovers",
            "The tenant can leave with one month's notice, which leaves a window to fill",
            "The eligibility document must be attached to the contract, otherwise the lease may be reclassified as a one-year furnished lease",
            "The term can never exceed ten months"
          ]
        }
      ],
      faqTitle: "Frequently asked questions",
      faq: [
        { question: "Can I get my property back for the summer?", answer: "Yes. That is the whole point of the arrangement. The mobility lease ends on its date, with no renewal and no notice to give." },
        { question: "Is a security deposit required?", answer: "No, the law expressly forbids it. The Visale guarantee replaces it and covers both unpaid rent and rental damage." },
        { question: "Must my property be registered with the town hall?", answer: "Not under the mobility lease. Registration concerns tourist rentals, not residential leases." },
        { question: "What about tax?", answer: "Income falls under the BIC regime for furnished lettings. We point you to your accountant for the choice between micro-BIC and the actual regime." },
        { question: "What if my property is not suitable?", answer: "We will tell you. Some properties, by their location or layout, remain more profitable in seasonal use all year round." }
      ],
      ctaTitle: "Estimate my property's hybrid potential",
      ctaDescription: "We analyse your calendar and your area, then tell you frankly whether the hybrid strategy makes sense for your property.",
      ctaButton: "Request an estimate"
    },
    conciergerie: {
      seoTitle: "Concierge Service Aix-en-Provence | Welcome, Maintenance & Property Care",
      seoDescription: "Personalised concierge service in Aix-en-Provence. Check-in/check-out, regular maintenance, emergency management, guest services. 7/7 assistance.",
      heroTitle: "Personalised Concierge Service in Aix-en-Provence",
      heroSubtitle: "Concierge",
      heroDescription: "We ensure the smooth running of your property and the comfort of your guests, with a single point of contact by your side every day.",
      sections: [
        {
          title: "Check-in / Check-out & Inventory",
          description: "Professional and warm welcome for your guests, with rigorous monitoring of your property's condition.",
          features: [
            "Personalized bilingual welcome (French / English)",
            "Regular furniture and equipment inventory",
            "Detailed condition report at each arrival and departure",
            "Key handover and property walkthrough"
          ]
        },
        {
          title: "Regular Maintenance",
          description: "Impeccable property upkeep through our network of qualified service providers and modern tracking tools.",
          features: [
            "Service provider contract management (cleaning, maintenance, etc.)",
            "Maintenance guide for service providers",
            "Mobile app for service management and tracking",
            "Daily cleaning and on-site laundry"
          ]
        },
        {
          title: "Emergency Management",
          description: "Responsiveness and efficiency in unexpected situations to protect your property and quickly resolve any issue.",
          features: [
            "Emergency repairs management (locksmith, plumber, electrician, pest control, etc.)",
            "Guest dispute and property/equipment damage management",
            "Damaged item replacement (funded via deposit or insurance)"
          ]
        },
        {
          title: "Guest Services",
          description: "Thoughtful touches and recommendations designed to make every stay memorable and inspire guests to return.",
          features: [
            "Local activities and experience recommendations",
            "Private chef and meal/grocery delivery",
            "Luggage storage service",
            "Private chauffeur and transfers",
            "Personalized restaurant and outing recommendations"
          ]
        }
      ],
      atouts: {
        title: "Our Strengths",
        items: [
          "A single point of contact who knows your property inside out",
          "Rigorous guest screening (ID verification & review check)",
          "Local assistance & maintenance 7/7",
          "Professional cleaning & inventory after every booking",
          "Passionate about the region — we're tour guides too!"
        ]
      },
      ctaTitle: "Trust Us with Your Property",
      ctaDescription: "Benefit from a comprehensive, personalized concierge service with a single dedicated point of contact for your property.",
      ctaButton: "Contact us",
      homeKeyPoints: [
        "Local assistance 7/7",
        "Personalized bilingual welcome",
        "Professional cleaning every stay",
        "Single dedicated contact"
      ]
    },
    staff: {
      seoTitle: "Staff Aix-en-Provence | Chefs, Cleaning & Events",
      seoDescription: "Household staff in Aix-en-Provence. Private chefs, cleaning staff, event service and childcare for your stays or events in Provence.",
      heroTitle: "Staff",
      heroSubtitle: "Household Staff",
      heroDescription: "Private chefs, cleaning staff and qualified service providers for your stays or events in Provence & the French Riviera.",
      sections: [
        { title: "Private Chefs", description: "Gastronomic experiences at home with our selected chefs.", features: ["In-house chef for your stay", "Bespoke menus tailored to your tastes", "Cooking classes with local specialities", "Catering for private events"] },
        { title: "Cleaning Staff", description: "Impeccable upkeep of your property.", features: ["Daily cleaning", "Property preparation before each arrival", "Laundry and linen service", "Deep cleaning on request"] },
        { title: "Event Service", description: "Professional staff for your receptions.", features: ["Maîtres d'hôtel and waiters", "Bartenders and mixologists", "Kitchen staff", "Event coordination"] },
        { title: "Childcare & Assistance", description: "Qualified personnel for your family.", features: ["Qualified babysitters", "Children's activity supervision", "Personal assistance", "Household help"] }
      ],
      atouts: { title: "Our Strengths", items: ["Rigorous staff selection", "Flexibility and availability", "Trusted local service providers", "Experienced and discreet personnel", "Bespoke service"] },
      ctaTitle: "Need Staff?",
      ctaDescription: "Contact us to arrange your bespoke household staff.",
      ctaButton: "Contact us",
      homeKeyPoints: ["Private chefs on request", "Professional cleaning staff", "Event service", "Taxi / Private chauffeur"]
    },
    partnerBadge: "Service offered through our partner",
    partnerWhy: "Why Choose Our Partner",
    partnerLabel: "Partner",
    partnerExpertise: "selected for their expertise and excellence",
    yachtCharter: {
      seoTitle: "Yacht Charter & Private Cruises French Riviera | Conciergerie Cabassol",
      seoDescription: "Yacht charters and private cruises in the Mediterranean. Day trips, sunset, all-inclusive weekly cruises. Partner service via Conciergerie Cabassol.",
      heroTitle: "Yacht Charter & Private Cruises",
      heroSubtitle: "Partner Service",
      heroDescription: "Explore the most beautiful Mediterranean coastlines aboard exceptional yachts. Our partner Alexander, an expert in nautical brokerage, offers bespoke charters from day trips to all-inclusive weekly cruises with professional crew and personalized itineraries.",
      sections: [
        {
          title: "Day Charters & Cruises",
          description: "Maritime getaways tailored to your every desire, from sunset outings to weekly cruises with full crew.",
          features: [
            "Day charters along the French Riviera",
            "Sunset outings with aperitif on board",
            "All-inclusive weekly cruises (crew, catering, water sports)",
            "Custom itineraries based on your preferences"
          ]
        },
        {
          title: "Fleet & Crew",
          description: "A carefully curated selection of yachts from 15 to 50 meters, each equipped with the latest technology and staffed by experienced professional crew.",
          features: [
            "Motor yachts and sailing yachts from 15 to 50 meters",
            "Certified, multilingual professional crew",
            "On-board private chef on request",
            "Full water sports equipment (jet-ski, paddle, diving)"
          ]
        },
        {
          title: "Events on Board",
          description: "Transform your yacht into a reception venue for unforgettable moments: private parties, team building or family celebrations in a unique setting.",
          features: [
            "Private parties and cocktails at sea",
            "Corporate team building and seminars",
            "Celebrations and anniversaries",
            "Gourmet catering service on board"
          ]
        },
        {
          title: "Destinations",
          description: "From the French Riviera to Corsica, Sardinia and the Greek islands, your horizon knows no limits.",
          features: [
            "French Riviera: Saint-Tropez, Cannes, Monaco, Antibes",
            "Corsica: Bonifacio, Porto-Vecchio, Calvi",
            "Sardinia: Costa Smeralda, Maddalena archipelago",
            "Greek Islands: Cyclades, Dodecanese, Ionian"
          ]
        }
      ],
      atouts: {
        title: "Why Choose Our Partner",
        items: [
          "Recognized expertise in nautical brokerage for over 10 years",
          "Varied fleet of rigorously selected yachts",
          "Bespoke service with personalized itineraries",
          "Certified, multilingual professional crew",
          "7/7 availability throughout the season",
          "Transparent pricing with no hidden fees"
        ]
      },
      ctaTitle: "Embark on the Extraordinary",
      ctaDescription: "Contact us to arrange your private Mediterranean cruise through our partner Alexander.",
      ctaButton: "Book through our partner"
    },
    billetterie: {
      seoTitle: "VIP Ticketing & Exclusive Access French Riviera | Conciergerie Cabassol",
      seoDescription: "VIP ticketing and exclusive access to French Riviera events. Cannes Film Festival, Monaco F1, private galas. Partner service via Conciergerie Cabassol.",
      heroTitle: "VIP Ticketing & Exclusive Access",
      heroSubtitle: "Partner Service",
      heroDescription: "Access the most exclusive and sought-after events on the French Riviera and beyond. Our partner Antoine, a luxury event specialist, opens the doors to the most prestigious cultural, sporting and social events.",
      sections: [
        {
          title: "Cannes Film Festival & Cinema",
          description: "Experience the Cannes Film Festival like an insider: official screenings, VIP parties on private beaches and exclusive premieres in an exceptional setting.",
          features: [
            "Official screening invitations at the Palais des Festivals",
            "Access to private parties on the Croisette beaches",
            "VIP premieres and screenings",
            "Meet actors and directors"
          ]
        },
        {
          title: "Fashion & Art",
          description: "Dive into the heart of contemporary creation: Fashion Weeks, private openings and exclusive exhibitions in the most prestigious galleries and foundations.",
          features: [
            "Front row at international Fashion Weeks",
            "Private openings and artist meetings",
            "Exclusive exhibitions and private collections",
            "Contemporary art fairs (Art Basel, FIAC)"
          ]
        },
        {
          title: "Sports & Grand Prix",
          description: "The most prestigious sporting events with privileged access: F1 paddock in Monaco, VIP boxes at regattas and matches in the best conditions.",
          features: [
            "Monaco F1 Grand Prix (paddock, yacht, VIP terraces)",
            "Regattas and nautical events (Voiles de Saint-Tropez)",
            "VIP matches in the greatest stadiums",
            "Exclusive golf and tennis tournaments"
          ]
        },
        {
          title: "Galas & Exclusive Evenings",
          description: "High-society events reserved for insiders: charity galas, networking evenings and private celebrations in the most iconic venues.",
          features: [
            "Charity galas and fundraising events",
            "High-end networking events",
            "Private parties in villas and yachts",
            "Private concerts and invitation-only events"
          ]
        }
      ],
      atouts: {
        title: "Why Choose Our Partner",
        items: [
          "Privileged access network to the most exclusive events",
          "Guaranteed seats even for sold-out events",
          "Personalized support before and during the event",
          "Complete coordination (transport, dress code, protocol)",
          "Event expertise for over 8 years",
          "Backstage access and VIP meetings"
        ]
      },
      ctaTitle: "Experience the Exceptional",
      ctaDescription: "Contact us to book your VIP access to the most prestigious events through our partner Antoine.",
      ctaButton: "Book through our partner"
    },
    automobiles: {
      seoTitle: "Prestige Automobiles French Riviera | Supercar Rental & Experiences",
      seoDescription: "Supercar rental, track experiences, car rallies and private chauffeur on the French Riviera. Partner service via Conciergerie Cabassol.",
      heroTitle: "Prestige Automobiles",
      heroSubtitle: "Partner Service",
      heroDescription: "Experience automotive excellence on the most beautiful roads of Provence and the French Riviera. Our partner Bowoods Travel, a passionate expert in prestige vehicles, offers supercar rentals, private track experiences and a premium chauffeur service.",
      sections: [
        {
          title: "Supercar Rental",
          description: "An exclusive collection of exceptional vehicles delivered directly to your door: Ferrari, Lamborghini, Porsche, McLaren and many more prestige marques.",
          features: [
            "Personalized delivery and collection at your address",
            "Varied fleet: sports cars, GTs, convertibles, luxury sedans",
            "Premium all-risk insurance included",
            "Flexible mileage adapted to your needs"
          ]
        },
        {
          title: "Track Experiences",
          description: "Unforgettable days on the most prestigious circuits in the South of France with professional driving coaching and race cars.",
          features: [
            "Private track days (Paul Ricard, Lédenon)",
            "Driving coaching with professional instructors",
            "Access to race cars and supercars",
            "Individual or group packages (team building, stag/hen)"
          ]
        },
        {
          title: "Rallies & Gatherings",
          description: "Participate in the most prestigious automotive events in the region: touring rallies, collector gatherings and exclusive road trips.",
          features: [
            "Bespoke touring rally organization",
            "Supercar and collection gatherings",
            "Exclusive road trips on Provence's legendary roads",
            "Private visits to museums and automotive collections"
          ]
        },
        {
          title: "Private Chauffeur",
          description: "A premium private chauffeur service for transfers, touring circuits and events, with luxury vehicles and absolute discretion.",
          features: [
            "Airport, station and heliport transfers",
            "Personalized touring circuits in Provence",
            "Event service (weddings, galas, parties)",
            "24/7 availability with on-demand booking"
          ]
        }
      ],
      atouts: {
        title: "Why Choose Our Partner",
        items: [
          "Exclusive fleet of rigorously maintained vehicles",
          "Door-to-door delivery across the French Riviera",
          "Premium all-risk insurance included",
          "Perfect knowledge of the region's most beautiful roads",
          "Dedicated, responsive 7/7 customer service",
          "Competitive and transparent pricing"
        ]
      },
      ctaTitle: "Take the Wheel of Excellence",
      ctaDescription: "Contact us to book your prestige vehicle or arrange your automotive experience through our partner Bowoods Travel.",
      ctaButton: "Book through our partner"
    }
  },
  seo: {
    home: { title: "Concierge & Property Management", description: "Concierge services and exceptional property management in Provence & the French Riviera." },
    services: { title: "Our Services - Property Management, Concierge & Yacht Charter", description: "Discover our tailored services: property management, personalised concierge, yacht charter and exclusive experiences." },
    about: { title: "About Us - Our Story and Team", description: "Discover Conciergerie Cabassol, experts in tailored lifestyle services on the French Riviera since 2020." },
    contact: { title: "Contact - Schedule a Meeting with Our Team", description: "Contact Conciergerie Cabassol for your property management, concierge and tailored lifestyle needs." },
    blog: { title: "Blog - Luxury Property Management Tips & Insights", description: "Expert articles on luxury property management and real estate investment on the French Riviera." },
    legal: { title: "Legal Notice & Privacy Policy", description: "Legal notice and privacy policy of Conciergerie Cabassol." },
    apartments: { title: "Luxury Accommodation in Provence & the French Riviera", description: "Discover our selection of exceptional villas and apartments in Aix-en-Provence, Saint-Tropez, Cannes and Nice." }
  }
};
